'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utils = {
  $$: function $$(el, parent) {
    if (!parent) {
      return document.querySelectorAll(el);
    } else {
      return parent.querySelectorAll(el);
    }
  },
  setCss: function setCss(el, props) {
    var prop = void 0;
    for (prop in props) {
      if (props.hasOwnProperty(prop)) {
        el.style[prop] = props[prop];
      }
    }
    return el;
  },
  translate: function translate(el, value, direction) {
    if (direction === 'y') {
      this.setCss(el, {
        'transform': 'translate3d(0,' + value + 'px,0)',
        '-webkit-transform': 'translate3d(0,' + value + 'px,0)'
      });
    } else if (direction === 'x') {
      this.setCss(el, {
        'transform': 'translate3d(' + value + 'px,0,0)',
        '-webkit-transform': 'translate3d(' + value + 'px,0,0)'
      });
    }
  },
  addClassToOneEle: function addClassToOneEle(els, theOne) {
    for (var j = els.length - 1; j >= 0; j--) {
      els[j].classList.remove('active');
    }
    els[theOne].classList.add('active');
  },

  transitionEvent: whichTransitionEvent()

};

function whichTransitionEvent() {
  var t = void 0;
  var el = document.createElement('fakeelement');
  var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MsTransition': 'msTransitionEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

exports.default = (0, _create2.default)(utils);




//////////////////
// WEBPACK FOOTER
// ./~/notone/utils.js
// module id = 451
// module chunks = 2